import { render } from "./Variables.vue?vue&type=template&id=24d47b15&scoped=true"
import script from "./Variables.vue?vue&type=script&lang=js"
export * from "./Variables.vue?vue&type=script&lang=js"

import "./Variables.vue?vue&type=style&index=0&id=24d47b15&scoped=true&lang=scss"

import exportComponent from "/home/itube/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d47b15"]])

export default __exports__